/**
 *
 * ResultsDrTableHead
 *
 */

import React, { memo, FunctionComponent } from 'react';
import SortIndicatorComponent from '../../../../components/SortIndicator/SortIndicator.component';
import { JudgeNamePosition, Sort } from '../../../../domain';

interface IProps {
  youngHorseResultsRule?: boolean;
  judges?: JudgeNamePosition[];
  changeSort: (field: string) => void;
  sort?: Sort;
  disabledFields: string[];
}

const ResultsDRTableHead: FunctionComponent<IProps> = ({
  judges = [],
  sort,
  changeSort,
  disabledFields,
  youngHorseResultsRule,
}) => {
  return (
    <thead>
      <tr>
        <th scope="col">
          <SortIndicatorComponent
            field="eaEventClassAndSort"
            name="Class"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        <th scope="col">
          <SortIndicatorComponent
            field="sectionName"
            name="Section"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        <th scope="col" colSpan={3}>
          <SortIndicatorComponent
            field="bridleNumber"
            name="Rider/BN"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        <th scope="col" className="tablet-hidden">
          <SortIndicatorComponent
            field="dressageTime"
            name="Time"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        {judges.length > 1 &&
          judges.map((judge, index) => (
            <th scope="col" key={index}>
              <SortIndicatorComponent
                field={`judgeScore${index + 1}`}
                name={judge.position || `Judge ${index + 1}`}
                sort={sort}
                changeSort={changeSort}
                disabledFields={disabledFields}
                tooltip={judge.name}
              />
            </th>
          ))}
        <th scope="col">
          <SortIndicatorComponent
            field="dressageScore"
            name="Score"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        <th scope="col">
          <SortIndicatorComponent
            field="dressageCollective"
            name="Colls"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        <th scope="col">
          <SortIndicatorComponent
            field="eaDressagePercentageCustom"
            name={youngHorseResultsRule ? 'Mark' : '%'}
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        <th scope="col">
          <SortIndicatorComponent
            field="sectionPlace"
            name="SP"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        <th scope="col">
          <SortIndicatorComponent
            field="overallPlace"
            name="OP"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        <th scope="col">
          <SortIndicatorComponent
            field="riderClassStatusName"
            name="Status"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
      </tr>
    </thead>
  );
};

export default memo(ResultsDRTableHead);
